// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setup-flow {
  min-height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
}

.setup-progress {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  padding: 20px 40px;
  position: sticky;
  z-index: 50;
}

.progress-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  max-width: 1000px;
  margin: 0 auto;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
}

.progress-step:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 16px;
  left: calc(100% + 20px);
  width: 40px;
  height: 2px;
  background: #e5e7eb;
  z-index: -1;
}

.progress-step.completed:not(:last-child)::after {
  background: #10b981;
}

.step-indicator {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}

.progress-step.active .step-indicator {
  background: #3b82f6;
  color: white;
}

.progress-step.completed .step-indicator {
  background: #10b981;
  color: white;
}

.step-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  text-align: center;
}

.progress-step.active .step-label {
  color: #3b82f6;
  font-weight: 600;
}

.progress-step.completed .step-label {
  color: #10b981;
}

.setup-content {
  flex: 1 1;
  background: #f8fafc;
}

@media (max-width: 768px) {
  .setup-progress {
    padding: 15px 20px;
  }

  .progress-steps {
    gap: 20px;
    overflow-x: auto;
    padding: 0 10px;
  }

  .progress-step:not(:last-child)::after {
    width: 20px;
    left: calc(100% + 10px);
  }

  .step-indicator {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }

  .step-label {
    font-size: 11px;
    white-space: nowrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/SetupFlow.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":[".setup-flow {\n  min-height: calc(100vh - 70px);\n  display: flex;\n  flex-direction: column;\n}\n\n.setup-progress {\n  background: white;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 20px 40px;\n  position: sticky;\n  z-index: 50;\n}\n\n.progress-steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 40px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n.progress-step:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  top: 16px;\n  left: calc(100% + 20px);\n  width: 40px;\n  height: 2px;\n  background: #e5e7eb;\n  z-index: -1;\n}\n\n.progress-step.completed:not(:last-child)::after {\n  background: #10b981;\n}\n\n.step-indicator {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.progress-step.active .step-indicator {\n  background: #3b82f6;\n  color: white;\n}\n\n.progress-step.completed .step-indicator {\n  background: #10b981;\n  color: white;\n}\n\n.step-label {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n  text-align: center;\n}\n\n.progress-step.active .step-label {\n  color: #3b82f6;\n  font-weight: 600;\n}\n\n.progress-step.completed .step-label {\n  color: #10b981;\n}\n\n.setup-content {\n  flex: 1;\n  background: #f8fafc;\n}\n\n@media (max-width: 768px) {\n  .setup-progress {\n    padding: 15px 20px;\n  }\n\n  .progress-steps {\n    gap: 20px;\n    overflow-x: auto;\n    padding: 0 10px;\n  }\n\n  .progress-step:not(:last-child)::after {\n    width: 20px;\n    left: calc(100% + 10px);\n  }\n\n  .step-indicator {\n    width: 28px;\n    height: 28px;\n    font-size: 12px;\n  }\n\n  .step-label {\n    font-size: 11px;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
